import React from "react";
import "./SelectItemsTable.css";
import GridIcon from "../../../assets/icons/grid.svg";
import ReportIcon from "../../../assets/icons/report-dash-icon.svg";

const statusConfig = {
  Published: { label: "Published", className: "status-published" },
  Draft: { label: "Draft", className: "status-draft" },
  Archived: { label: "Archived", className: "status-archived" },
};

/* Rows come from /home-summary now (see homeApi.js recentItems). The mock array
   that used to stand in for them is kept below, commented, in case the page has
   to be demoed without a backend — but it is no longer a *fallback*: an org with
   no boards yet has to show an empty state, not five invented dashboards.

  const defaultItems = [
    { id: 1, name: "Q2 Performance Dashboard", subtype: "Dashboard", type: "Dashboard",
      createdBy: "Justin Fagundez", status: "Published", timestamp: "May 6, 2025 11:42 AM" },
    { id: 2, name: "Customer Churn Report", subtype: "Report", type: "Report",
      createdBy: "Sarah Chen", status: "Draft", timestamp: "May 5, 2025 4:20 PM" },
    { id: 3, name: "Weekly Sales Summary", subtype: "Report", type: "Report",
      createdBy: "Marcus Rivera", status: "Published", timestamp: "May 5, 2025 9:15 AM" },
    { id: 4, name: "Product Usage Metrics", subtype: "Dashboard", type: "Dashboard",
      createdBy: "Justin Fagundez", status: "Archived", timestamp: "May 4, 2025 2:38 PM" },
    { id: 5, name: "Marketing Funnel Q1", subtype: "Dashboard", type: "Dashboard",
      createdBy: "Emily Park", status: "Published", timestamp: "May 3, 2025 10:00 AM" },
  ];
*/

const SelectItemsTable = ({ items = [], loading = false, error = null, onViewAll }) => {
  const displayItems = items;

  /* Loading, failed and empty are mutually exclusive with the rows, and all
     three read the same way — one cell spanning the five columns, so the header
     stays put and the card keeps its height between states. Loading wins over an
     error so a refetch does not keep showing the last failure. */
  const placeholder = loading
    ? "Loading…"
    : error
      ? "Could not load your dashboards and reports."
      : displayItems.length === 0
        ? "No dashboards or reports yet."
        : null;

  return (
    <div className="dashboard-items-table-container">
      <div className="table-header">
        <h3 className="table-title">Recent Dashboards & Reports</h3>
        <button className="view-all-btn" onClick={onViewAll}>
          View All
        </button>
      </div>

      <div className="table-wrapper">
        <table className="dashboard-items-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              {/* <th>Created By</th> */}
              <th>Status</th>
              <th>Updated</th>
            </tr>
          </thead>
          <tbody>
            {/* Loading, failed and empty all land in one cell spanning the five
                columns, so the header row stays put and the card keeps its
                height instead of collapsing between states. */}
            {placeholder !== null ? (
              <tr>
                {/* Four columns while Created By is commented out above — a
                    colSpan wider than the table leaves the placeholder
                    stretching past the last header. */}
                <td colSpan={4} className="table-placeholder">
                  {placeholder}
                </td>
              </tr>
            ) : null}
            {(placeholder === null ? displayItems : []).map((item) => (
              <tr key={item.id}>
                <td>
                  <div className="name-cell">
                    <div className="name-icon">
                      <img src={item.type === "Dashboard" ? GridIcon : ReportIcon} alt={item.type} />
                    </div>
                    <div>
                      <div className="name-primary">{item.name}</div>
                      <div className="name-secondary">{item.subtype}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <span className={`type-badge type-${item.type?.toLowerCase()}`}>{item.type}</span>
                </td>
                {/* <td className="created-by-cell">{item.createdBy}</td> */}
                <td>
                  <span className={`status-badge ${statusConfig[item.status]?.className}`}>{item.status}</span>
                </td>
                <td className="timestamp-cell">{item.timestamp}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SelectItemsTable;
